import * as React from 'react'
import classnames from 'classnames'
import './styles.ts'
import { Content, StyledToolTip, Subtitle, Wrapper } from './styles'
import { DolaThemes } from '../../styles/types'

interface TooltipProps {
  content: React.ReactChild
  subtitle?: React.ReactChild
  size?: 'short' | 'long'
  caretPosition?: 'left' | 'center' | 'right'
  theme?: DolaThemes
}

const Tooltip: React.FC<TooltipProps> = ({
  content,
  subtitle,
  children,
  size = 'short',
  caretPosition = 'center',
  theme = 'light',
}) => {
  const isShort = size === 'short'
  const isCaretCenter = caretPosition === 'center'
  const isCaretLeft = caretPosition === 'left'
  return (
    <Wrapper>
      <StyledToolTip
        isCaretCenter={isCaretCenter}
        isCaretLeft={isCaretLeft}
        isShort={isShort}
        dolaTheme={theme}
        className="tooltip"
      >
        <Content>{content}</Content>
        {subtitle && (
          <Subtitle className={classnames('subtitle')}>{subtitle}</Subtitle>
        )}
      </StyledToolTip>
      {children}
    </Wrapper>
  )
}

export default Tooltip
